"use client";

import React from "react";
import { Container } from "react-bootstrap";
import packageJson from "../../../package.json";

const appVersion = packageJson.version;

const Footer: React.FC = () => {
    // Get current environment
    const appEnv =
        process.env.NEXT_PUBLIC_ENV || process.env.NODE_ENV || "development";

    return (
        <>
            <footer className="footer-custom py-3 mt-auto">
                <Container fluid>
                    <div className="footer-content">
                        {/* Centered Copyright */}
                        <div className="footer-copyright text-center">
                            <p
                                className="mb-0 text-muted"
                                style={{ fontSize: "0.875rem" }}
                            >
                                &copy; Dispatch-IQ New York Blood Center{" "}
                                {new Date().getFullYear()}. Version {appVersion}
                            </p>
                        </div>

                        {/* Right side - Environment */}
                        <div className="footer-environment">
                            <span
                                className="text-muted"
                                style={{ fontSize: "0.875rem" }}
                            >
                                Environment: {appEnv.toUpperCase()}
                            </span>
                        </div>
                    </div>
                </Container>
            </footer>

            <style jsx global>{`
                :root {
                    --app-footer-height: 64px;
                }

                .footer-custom {
                    background-color: #f3f3f3 !important;
                    border-top: 1px solid #e0e0e0;

                    width: 100%;
                    box-sizing: border-box;
                    min-height: var(--app-footer-height);
                }

                .footer-content {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    width: 100%;
                    max-width: 100%;
                    box-sizing: border-box;
                }

                .footer-copyright {
                    flex: 1;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    max-width: 100%;
                    box-sizing: border-box;
                }

                .footer-environment {
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    display: flex;
                    align-items: center;
                    white-space: nowrap;
                    max-width: 200px;
                    box-sizing: border-box;
                }

                /* Dark theme support */
                html[data-bs-theme="dark"] .footer-custom,
                body[data-bs-theme="dark"] .footer-custom {
                    background-color: #2b2f33 !important;
                    border-top-color: #495057 !important;
                }

                html[data-bs-theme="dark"] .footer-custom .text-muted,
                body[data-bs-theme="dark"] .footer-custom .text-muted {
                    color: #adb5bd !important;
                }

                /* Mobile responsiveness */
                @media (max-width: 768px) {
                    .footer-content {
                        flex-direction: column;
                        gap: 0.5rem;
                        padding: 0.5rem 0;
                    }

                    .footer-copyright {
                        flex: none;
                        text-align: center;
                    }

                    .footer-environment {
                        position: static;
                        transform: none;
                        justify-content: center;
                        max-width: 100%;
                    }
                }

                /* SAFE overflow prevention - only for body, not containers */
                body {
                    overflow-x: hidden;
                }

                /* Safe container styling - NO overflow hidden */
                .footer-custom .container-fluid {
                    padding-left: 1rem;
                    padding-right: 1rem;
                    max-width: 100%;
                    box-sizing: border-box;
                }
            `}</style>
        </>
    );
};

export default Footer;
